import React, { useEffect, useState } from 'react'
import HeaderIcon from '../../assets/images/header-icon/camera.png'
import { Tab } from '../../components/master/Tab'
import UploadCarImages from '../../components/pages/complete/UploadCarImages'
import { getQueryString, hardCopy, pexios, uploadImages } from '../../utils/functions';
import { useSelector } from 'react-redux';
import UploadDocs from '../../components/pages/complete/UploadDocs';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import { alphabet, history, url } from '../../utils/variables';
import ImageZoom from '../../components/master/ImageZoom';
import Modal from '../../components/master/Modal';
import addImage from '../../assets/images/AddImagePlaceholder/addImage.png';

function ImagesComplement() {
    const [attachments,setAttachments] = useState([])
    const [imgUid, setImgUid] = useState(null);
    const [loader,setLoader] = useState(false);
    const {id} = useSelector((store) => store.routerData)
    const images = attachments.filter(img=>img.filename.includes('cul_crash_image'));
    const lossesCount = parseInt(getQueryString('losses_count')) || 0
    useEffect(()=>{
        setLoader(true)
        pexios(`api/get_accident_photos/${id}`)
        .then((res)=>{
            setAttachments(res.data.attachments)
            setLoader(false)
        })
    },[id])
    function uploadDoc(image, name, done) {
            let copyAttachments = hardCopy(attachments);
            const index = copyAttachments.findIndex(img => img.filename === name);
            uploadImages({
                id,
                type: 'accident',
                name,
                image,
                done,
                callback: (data) => {
                    if (index !== -1) copyAttachments[index] = data;
                    else copyAttachments.push(data);
                    setAttachments(copyAttachments);
                },
            });
        }
  return (
    <div className='content complete'>
        <Modal visible={imgUid}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setImgUid(null)}
                />
                <ImageZoom imgUid={imgUid}/>
            </div>
        </Modal>
        {loader ?
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
        :
        <>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <p className='guide-text mx10 mt10 mb30'>
        کاربر محترم ، در این قسمت میتوانید تصاویر مربوط به پرونده خود را مشاهده کرده و نسبت به تکمیل تصاویر مورد نیاز اقدام فرمایید.  
        </p>

        <Tab title="تصاویر مقصر">
            <div className='d-flex flex-row-reverse flex-wrap'>
                <UploadCarImages
                    attachments={attachments}
                    uploadDoc={uploadDoc}
                    userType='culprit'
                />
                <UploadDocs
                    attachments={attachments}
                    insuranceType={!lossesCount ? 'body' :'third'}
                    uploadDoc={uploadDoc}
                    userType='culprit'
                />  
            </div>

        </Tab>
        {!!lossesCount && Array(lossesCount).fill('').map((loss,index)=>(
            <Tab title={`تصاویر زیان دیده ${alphabet[index]}`}>
            <div className='d-flex flex-row-reverse flex-wrap'>
                <UploadCarImages
                    attachments={attachments}
                    uploadDoc={uploadDoc}
                    userType='losses'
                    lossesIndex={index+1}
                />
                <UploadDocs
                    attachments={attachments}
                    uploadDoc={uploadDoc}
                    userType='losses'
                    lossesIndex={index+1}
                />  
            </div>
            </Tab>
        ))}
        <Tab title="تصاویر تکمیلی حادثه">
            <div className="image-complete">
                <div className='box m0 p10'>
                    <div className='imageBox rtl'>
                    {images.map(img=>(
                        <div className='imageParent register-image-parent' key={img.id}>
                            <img
                                onClick={() => setImgUid(img.uid)}
                                src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                                alt='img'
                                id={img.id}
                            />
                        </div>
                    ))}
                    <div className='imageParent register-image-parent'>
                        <ImagePickerModal
                            renderBtn={<div className='add-image'><img src={addImage} alt='img'/></div>}
                            upload={(image, done) => uploadDoc(image,`cul_crash_image_${images.length +1}`, done)}
                        />
                                {/* <p className='image-label cul'>
                                    {t('Completment image')}
                                </p> */}
                    </div>
                    </div>
                </div>
            </div>
         </Tab>
         <div className='d-flex justify-center mt30'>
            <button 
                className='btn btn-circle btn-block btn-orange w-50'
                onClick={()=> history.push('/accident-report')}
                >بازگشت به پرونده 
            </button>
        </div>
        </>
       }
    </div>
  )
}

export default ImagesComplement